import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import pos from "../../Assets/Projects/pos.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import student_sys from "../../Assets/Projects/student-sys.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
import jovi from '../../Assets/Projects/jovi-app-new.jpg';
import events from '../../Assets/Projects/events.png';
import pdf_gen from '../../Assets/Projects/pdf-gen.png';




function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={jovi}
              isBlog={false}
              title="JOVI"
              description="Jovi has the answer to all your needs in the palm of your hand. From food to grocery delivery to the errands you've been procrastinating to complete. Anything, Anywhere, Anytime - Jovi Chaho, MangWOW!"
              // link="https://github.com/Malik-93/Chatify-master"
              demo={"https://play.google.com/store/apps/details?id=com.jovirider&hl=en&gl=US"}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={events}
              isBlog={false}
              title="Events"
              description="An event booking application where users can see upcoming, live and past events and can reserve their slots before the event start.!"
              // link="https://github.com/Malik-93/locally-frontend"
              demo={"https://locally-v3-16ef4.web.app/"}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={student_sys}
              isBlog={false}
              title="Student Management Sytem"
              description="A Full Stack Web Application built with Node.js, Express.js, MongoDB and Bootstrap for managing all the tasks and activities of a student within an Institution.
              A powerful Login and Authentication System - Role based authentication and authorization.
Student Details – Displays the details of all the students, and provides following services: a. Adding a new student. b. Editing / Modifying the data of an existing student. c. Deleting / Removing the data of an existing student.
Course Details – Lis the details of all the courses available in the institution, and provides following services: a. Adding a new course. b. Editing an existing course. c. Deleting a course.
Fee Details.
Marks and Grades.
Attendance.
              "
              // link="https://github.com/Malik-93/Student-mgt-sys"
              demo={"https://student-mgt-sys.herokuapp.com/"}
            />
          </Col>

        </Row>
        <Row>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pdf_gen}
              isBlog={false}
              title="PDF Generator"
              description="A MERN STACK app where you can generate PDF from HTML."
              // link="https://github.com/Malik-93/Chatify-master"
              demo={"https://scrapy-bf04e.web.app/?title=This%20is%20a%20sample%20document%20which%20generated%20from%20a%20web%20page%20to%20pdf%20document&pageSize=1&ItemId=12345678901&price=100"}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Chatify"
              description="Personal Chat Room or Workspace to share resources and hangout with friends build with react.js, Material-UI, and Firebase. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages."
              // link="https://github.com/Malik-93/Chatify-master"
              demo={"https://chitchat-3734f.web.app"}
            />
          </Col>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pos}
              isBlog={false}
              title="Store Point of Sale (POS)"
              description={`A Full Stack Web Application built with Node.js, Express.js, Electron, neDB and Bootstrap for managing all the stocks, orders and transactions within a Store.
              \n
              Features:\n
Can be used by multiple PC's on a network with one central database.
Receipt Printing.
Search for product by barcode.
Staff accounts and permissions.
Products and Categories.
Basic Stock Management.
Open Tabs (Orders).
Customer Database.
Transaction History.
Filter Transactions by Till, Cashier or Status.
Filter Transactions by Date Range.
              `}
            // link="https://github.com/Malik-93/Ghazi_POS_System"
            // demo={"https://student-mgt-sys.herokuapp.com/"}
            />
          </Col>
       
        </Row>
        <Row>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Editor.io"
              description="Online code and markdown editor build with react.js. Online Editor which supports html, css, and js code with instant view of website. Online markdown editor for building README file which supports GFM, Custom Html tags with toolbar and instant preview.Both the editor supports auto save of work using Local Storage"
              // link="https://github.com/Malik-93/Editor.io-master"
              demo={"https://editor-io-1d2e0.web.app"}
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Bits-0f-C0de"
              description="My personal blog page build with Next.js and Tailwind Css which takes the content from makdown files and renders it using Next.js. Supports dark mode and easy to write blogs using markdown."
              // link="https://github.com/Malik-93/Bits-0f-Code"
              demo={"https://bits-of-codes.web.app"}

            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
